export default {
  brands: []
}
